import Coastline from "../Assets/Photos/Coastline.jpeg";
import NationalHypnoBoardLogo from "../Assets/national-hypno-board.jpg";
import Seo from "../Components/Seo";

const pricing = [
  {
    title: "Initial consultation",
    price: "FREE",
    note: "A calm, no-obligation conversation to understand your goals. A free sleep track included!"
  },
  {
    title: "One-off 60 minute session",
    price: "£70",
    note: "Single standalone session."
  },
  {
    title: "Block of 6 sessions",
    price: "£400",
    note: "Usually £420, saving £20."
  },
  {
    title: "Block of 9 sessions",
    price: "£580",
    note: "Usually £630, saving £50."
  },
  {
    title: "2-hour smoking/vaping cessation",
    price: "£175",
    note: "Focused cessation session."
  }
];

export default function Investment() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 pb-10">
      <Seo
        title="Investment"
        description="View Calm Coast Hypnotherapy pricing, session options and package savings for in-person and online support."
        path="/investment"
      />
      <section className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-3">
          <p className="text-sm font-semibold uppercase tracking-wide text-coastal-600">Pricing</p>
          <h1 className="mt-2 font-roboto text-4xl font-semibold text-coastal-800">Investment</h1>
          <p className="mt-3 text-slate-700">
            Transparent pricing for focused, evidence-informed hypnotherapy support.
          </p>
        </div>
        <div className="md:col-span-2">
          <img src={Coastline} alt="Coastal beach scene" className="h-full min-h-[240px] w-full rounded-2xl object-cover" />
        </div>
      </section>

      <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {pricing.map((item) => (
          <article key={item.title} className="rounded-2xl bg-coastal-50 p-5 ring-1 ring-coastal-100">
            <h2 className="font-roboto text-xl font-semibold text-coastal-800">{item.title}</h2>
            <p className="mt-2 text-3xl font-bold text-coastal-700">{item.price}</p>
            <p className="mt-2 text-slate-700">{item.note}</p>
          </article>
        ))}
      </section>

      <section className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-center">
          <img
            src={NationalHypnoBoardLogo}
            alt="National Board for Hypnotherapy accredited"
            className="h-20 w-auto rounded-md bg-white p-1 ring-1 ring-coastal-100"
          />
          <div>
            <h2 className="font-roboto text-2xl font-semibold text-coastal-800">Accreditation</h2>
            <p className="mt-1 text-slate-700">
              Carly is accredited by the National Board for Hypnotherapy (NBH).
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
